import ShippingListContainer from './ShippingListContainer';
export default ShippingListContainer;
